import { render, staticRenderFns } from "./ServiceSelection.vue?vue&type=template&id=688a9478&"
import script from "./ServiceSelection.vue?vue&type=script&lang=ts&"
export * from "./ServiceSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports